<template>
    <div id="tempcreate-layer">
<!--        <light-header :back="backUrl"></light-header>-->
        <div class="title-top flex-center">
            <div class="flex-center">
                <svg-icon icon-class="cross-close" style="cursor: pointer;" width="30" height="30"
                          @click="closeTitleTop"></svg-icon>
                <div class="title">完善组织机构认证资料</div>
            </div>
            <div class="flex-center">
                <el-button type="primary" size="small" style="margin-left: 20px;" @click="confirmSubmit" :disabled="formLoading"
                           >确认提交</el-button>
            </div>
        </div>
        <div class="tempcreate-content auto" v-loading="formLoading">
            <div class="tempcreate-files">
                <el-form :model="filesForm" :rules="filesRules" ref="filesForm" label-width="180px"
                         label-position="left"
                         class="files-Form" >
                    <div id="company-info-layer">
                        <div class="area-title">
                            <span class="bar"></span>
                            <span class="title">基本信息</span>
                        </div>
                        <div class="padding-20">
                        <el-form-item prop="companyName" label="企业名称" :rules="[
              {
                required: true,
                message: '请输入企业名称',
                trigger: 'blur',
              },
            ]">
                            <el-input maxlength="50" show-word-limit size="small" v-model="filesForm.companyName" placeholder="请输入企业名称">
                            </el-input>
                        </el-form-item>


                        <el-form-item prop="companyNo" label="企业统一社会信用代码" :rules="[
              {
                required: true,
                message: '请输入企业统一社会信用代码',
                trigger: 'blur',
              },
              { validator: checkCompanyID, trigger: 'blur' },
            ]">
                            <el-input maxlength="18" show-word-limit size="small" v-model="filesForm.companyNo" placeholder="请输入企业统一社会信用代码">
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="legalName" label="法定代表人姓名" :rules="[
              {
                required: true,
                message: '请输入法定代表人姓名',
                trigger: 'blur',
              },
              { validator: checkChinese, trigger: 'blur' },
            ]">
                            <el-input maxlength="4" show-word-limit size="small" v-model="filesForm.legalName" placeholder="请输入法定代表人姓名">
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="legalNo" label="法定代表人身份证号" :rules="[
              {
                required: true,
                message: '请输入法定代表人身份证号',
                trigger: 'blur',
              },
              { validator: checkID, trigger: 'blur' },
            ]">
                            <el-input maxlength="18" show-word-limit size="small" v-model="filesForm.legalNo" placeholder="请输入法定代表人身份证号">
                            </el-input>
                        </el-form-item>
                        <!--            <el-form-item prop="legalPhone" label="法定代表人联系电话" :rules="[-->
                        <!--              {-->
                        <!--                required: true,-->
                        <!--                message: '请输入法定代表人联系电话',-->
                        <!--                trigger: 'blur',-->
                        <!--              },-->
                        <!--            ]">-->
                        <!--              <el-input maxlength="100" v-model="filesForm.legalPhone" placeholder="请输入法定代表人联系电话" style="width: 70%">-->
                        <!--              </el-input>-->
                        <!--            </el-form-item>-->
                        <el-form-item prop="agentName" label="经办人姓名" :rules="[
              {
                required: true,
                message: '请输入经办人姓名',
                trigger: 'blur',
              },
              { validator: checkChinese, trigger: 'blur' },
            ]">
                            <el-input maxlength="4" show-word-limit size="small" v-model="filesForm.agentName" placeholder="请输入经办人姓名">
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="agentNo" label="经办人身份证号" :rules="[
              {
                required: true,
                message: '请输入经办人身份证号',
                trigger: 'blur',
              },
              { validator: checkID, trigger: 'blur' },
            ]">
                            <el-input maxlength="18" show-word-limit size="small" v-model="filesForm.agentNo" placeholder="请输入经办人身份证号">
                            </el-input>
                        </el-form-item>
                    </div>
                    </div>
                    <div id="auth-info-company-layer">
<!--                        <div style="width: 100%">-->
<!--                            <div style="padding: 0 0 15px; width: 90%; margin: 0 auto">-->
<!--                                <el-divider content-position="center">企业证明材料</el-divider>-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="area-title">
                            <span class="bar"></span>
                            <span class="title">单位证明材料</span>
                        </div>
                        <el-form-item label-width="0" prop="licenseImgFileId" class="clearfix" :rules="[
              {
                required: true,
                message: '请上传企业营业执照',
                trigger: 'blur',
              },
            ]">
                            <div class="company-upload">
                                <el-upload accept=".png,.jpg,.jpeg" class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
                                           :headers="myHeaders"
                                           :data="upLoadData" :on-success="handleCompanyCardSuccess"
                                           :before-upload="handleCompanyCardBeforeUpload">
                                    <img v-if="filesForm.licenseImgBase64" :src="filesForm.licenseImgBase64"
                                         class="avatar"/>
                                    <i v-else class="el-icon-picture-outline avatar-uploader-icon"></i>
                                    <p class="upload-text">上传企业营业执照</p>
                                </el-upload>
                            </div>
                            <div class="upload-example">
                                <p>参考示例</p>
                                <div class="example-box">
                                    <el-image fit="fill" :src="
                    require('../../../assets/images/auth/company/company-img1.png')
                  " alt="" :preview-src-list="[
  require('../../../assets/images/auth/company/company-img1.png'),
]" style="width: 75px"></el-image>
                                </div>
                            </div>
                        </el-form-item>


                        <el-form-item style="margin-top: 0px !important" label-width="0" prop="legalFrontImgFileId"
                                      class="clearfix"
                                      :rules="[
                {
                  required: true,
                  message: '请上传法定代表人身份证头像面',
                  trigger: 'blur',
                },
              ]">
                            <div class="company-upload">
                                <el-upload accept=".png,.jpg,.jpeg" class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
                                           :headers="myHeaders"
                                           :data="upLoadData" :on-success="handleFrontCardSuccess"
                                           :before-upload="handleFrontCardBeforeUpload">
                                    <img v-if="filesForm.legalFrontImgBase64" :src="filesForm.legalFrontImgBase64"
                                         class="avatar"/>
                                    <i v-else class="el-icon-picture-outline avatar-uploader-icon"></i>
                                    <p class="upload-text">上传法定代表人身份证头像面</p>
                                </el-upload>
                            </div>
                            <div class="upload-example">
                                <p>参考示例</p>
                                <div class="example-box">
                                    <el-image fit="fill" :src="
                    require('../../../assets/images/auth/company/company-img2.png')
                  " alt="" :preview-src-list="[
  require('../../../assets/images/auth/company/company-img2.png'),
]" style="width: 145px"></el-image>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label-width="0" prop="legalBackImgFileId" class="clearfix" :rules="[
              {
                required: true,
                message: '请上传法定代表人身份证国徽面',
                trigger: 'blur',
              },
            ]">
                            <div class="company-upload">
                                <el-upload accept=".png,.jpg,.jpeg" class="avatar-uploader" :action="uploadUrl" :headers="myHeaders"
                                           :data="upLoadData"
                                           :show-file-list="false" :on-success="handleBackCardSuccess"
                                           :before-upload="handleBackCardBeforeUpload">
                                    <img v-if="filesForm.legalBackImgBase64" :src="filesForm.legalBackImgBase64"
                                         class="avatar"/>
                                    <i v-else class="el-icon-picture-outline avatar-uploader-icon"></i>
                                    <p class="upload-text">上传法定代表人身份证国徽面</p>
                                </el-upload>
                            </div>
                            <div class="upload-example">
                                <p>参考示例</p>
                                <div class="example-box">
                                    <el-image fit="fill" :src="
                    require('../../../assets/images/auth/company/company-img3.png')
                  " alt="" :preview-src-list="[
  require('../../../assets/images/auth/company/company-img3.png'),
]" style="width: 145px"></el-image>
                                </div>
                            </div>
                        </el-form-item>

                        <div class="area-title">
                            <span class="bar"></span>
                            <span class="title">经办人证明材料</span>
                        </div>

                        <el-form-item label-width="0" prop="authFileImgFileId" class="clearfix" :rules="[
              {
                required: true,
                message: '请上传组织机构认证授权书',
                trigger: 'blur',
              },
            ]">
                            <div class="company-upload">
                                <el-upload accept=".png,.jpg,.jpeg" class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
                                           :headers="myHeaders"
                                           :data="upLoadData" :on-success="handleAuthFileImgSuccess"
                                           :before-upload="handleHandleAuthFileImgSuccessBeforeUpload">
                                    <img v-if="filesForm.authFileImgBase64" :src="filesForm.authFileImgBase64"
                                         class="avatar"/>
                                    <i v-else class="el-icon-picture-outline avatar-uploader-icon"></i>
                                    <p class="upload-text">上传组织机构认证授权书</p>
                                </el-upload>
                            </div>
                            <div class="upload-example" style="height: auto">
                                <p>参考示例</p>
                                <div class="example-box-wrap">
                                    <div class="example-box">
                                        <!-- <img
                                          src="../../../assets/images/auth/company/company-auth-img.png"
                                          alt=""
                                          style="width: 70px"
                                        /> -->
                                        <el-image fit="fill" :src="
                      require('../../../assets/images/auth/company/company-auth-img.png')
                    " alt="" :preview-src-list="[
  require('../../../assets/images/auth/company/company-auth-img.png'),
]" style="width: 75px"></el-image>
                                    </div>
                                </div>
                            </div>
                            <div class="auth-img-tip-wrap">
                                <div>
                                    操作步骤说明：
                                </div>
                                <div>
                                    <a :href="authorizationAddress" target="_blank"
                                       style="text-decoration: underline;color: #3F7BF9;">1.点击此处下载授权书模板</a>
                                </div>
                                <div>
                                    2.填写授权书内容并加盖公章
                                </div>
                                <div>3.拍照上传授权书文件</div>
                                <div style="color: red">注：被授权人需与上面填写的经办人信息一致</div>
                            </div>
                        </el-form-item>

                        <el-form-item style="margin-top: 0px !important" label-width="0" prop="agentFrontImgFileId"
                                      class="clearfix"
                                      :rules="[
                {
                  required: true,
                  message: '请上传经办人身份证头像面',
                  trigger: 'blur',
                },
              ]">
                            <div class="company-upload">
                                <el-upload accept=".png,.jpg,.jpeg" class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
                                           :headers="myHeaders"
                                           :data="upLoadData" :on-success="handleFrontCardSuccessByAgent"
                                           :before-upload="handleFrontCardBeforeUpload">
                                    <img v-if="filesForm.agentFrontImgBase64" :src="filesForm.agentFrontImgBase64"
                                         class="avatar"/>
                                    <i v-else class="el-icon-picture-outline avatar-uploader-icon"></i>
                                    <p class="upload-text">上传经办人身份证头像面</p>
                                </el-upload>
                            </div>
                            <div class="upload-example">
                                <p>参考示例</p>
                                <div class="example-box">
                                    <el-image fit="fill" :src="
                    require('../../../assets/images/auth/company/company-img2.png')
                  " alt="" :preview-src-list="[
  require('../../../assets/images/auth/company/company-img2.png'),
]" style="width: 145px"></el-image>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label-width="0" prop="agentBackImgFileId" class="clearfix" :rules="[
              {
                required: true,
                message: '请上传经办人身份证国徽面',
                trigger: 'blur',
              },
            ]">
                            <div class="company-upload">
                                <el-upload accept=".png,.jpg,.jpeg" class="avatar-uploader" :action="uploadUrl" :headers="myHeaders"
                                           :data="upLoadData"
                                           :show-file-list="false" :on-success="handleBackCardSuccessByAgent"
                                           :before-upload="handleBackCardBeforeUpload">
                                    <img v-if="filesForm.agentBackImgBase64" :src="filesForm.agentBackImgBase64"
                                         class="avatar"/>
                                    <i v-else class="el-icon-picture-outline avatar-uploader-icon"></i>
                                    <p class="upload-text">上传经办人身份证国徽面</p>
                                </el-upload>
                            </div>
                            <div class="upload-example">
                                <p>参考示例</p>
                                <div class="example-box">
                                    <el-image fit="fill" :src="
                    require('../../../assets/images/auth/company/company-img3.png')
                  " alt="" :preview-src-list="[
  require('../../../assets/images/auth/company/company-img3.png'),
]" style="width: 145px"></el-image>
                                </div>
                            </div>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="sys-tip-layer">
                    <span class="title">温馨提示：</span>
                    <span class="sub">单位认证资料提交成功后将自动提交到平台审核，工作日当天审核完成，节假日顺延至工作日审核完成，审核结果将以短信方式通知。</span>
                </div>
            </div>
        </div>
<!--        <div class="tempcreate-users-box auto">-->
<!--            <div class="sign-btns">-->
<!--                <el-button type="primary" @click="handleSaveCompanyInfo" :disabled="formLoading">提 交</el-button>-->
<!--            </div>-->
<!--        </div>-->

        <el-dialog title="经办人实人认证" :visible.sync="agentAuthOpen" width="800px" append-to-body
                   :close-on-click-modal="false" :before-close="closeAgentAuth">
            <div style="margin-bottom: 10px;">
                <span>请经办人 </span>
                <span style="color: red">{{ filesForm.agentName }} </span>
                <span>本人根据提示完成刷脸认证，认证通过后系统将自动提交组织机构认证资料到平台。</span>
            </div>

            <div class="handle-sign">
                <img class="wexin" src="@/assets/images/sign/phone.png" alt="" width="450"
                     height="330">
                <div style="position: relative;top: 57px;left: 18px">
                    请使用微信扫描下方二维码，根据提示完成人脸认证
                </div>
                <div style="position: absolute;top: 110px;left: 85px">
                    <img :src="authCodeImg" alt="" style="width: 130px;height: 130px;">
                </div>
                <div v-if="qrcodeStatus == 'pass'" style="position: absolute;top: 110px;left: 85px;background: #FFFFFF;width: 130px;height: 130px;border-radius: 6px 6px 6px 6px;opacity: 0.95;">
                    <svg-icon iconClass="icon-enable"
                              style="position:absolute;width: 30px;height: 30px;margin-top: 36px;margin-left: 50px;" />
                    <div style="position:absolute;margin-top: 74px;margin-left: 43px;color:green">已通过</div>
                </div>
                <div v-if="qrcodeStatus == 'expired'" style="position: absolute;top: 110px;left: 85px;background: #FFFFFF;width: 130px;height: 130px;border-radius: 6px 6px 6px 6px;opacity: 0.95;">
                    <svg-icon iconClass="icon-yellow-warn"
                              style="position:absolute;width: 30px;height: 30px;margin-top: 36px;margin-left: 50px;" />
                    <div style="position:absolute;margin-top: 74px;margin-left: 23px;color:#EFB040">二维码已失效</div>
                </div>
                <div v-if="qrcodeStatus == 'notPass'" style="position: absolute;top: 110px;left: 85px;background: #FFFFFF;width: 130px;height: 130px;border-radius: 6px 6px 6px 6px;opacity: 0.95;">
                    <svg-icon iconClass="icon-disable"
                              style="position:absolute;width: 30px;height: 30px;margin-top: 36px;margin-left: 50px;" />
                    <div style="position:absolute;margin-top: 74px;margin-left: 29px;color:red">认证未通过</div>
                </div>
                <el-button plain round size="mini"
                           style="position: absolute;top: 256px;left: 118px" @click="shuaxinQrcode">
                    刷新
                    <i class="el-icon-refresh-right"></i>
                </el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
    // import { Loading } from "element-ui";\
    import {mapState} from "vuex";
    import {getToken, getConsoleUrl} from "@/utils/auth";
    import {contractTemplateImgApi} from "@/api/template/index";
    import {inspectTokenExpired} from "@/api/common";
    import {getComapnayAuthInfo, updateCompanyAuthInfo, getAgentAuthLink, getAgentAuthResult} from "@/api/auth/auth";
    import {
        authorizationAddressPath,
        submitCompanyAuthInfo,
    } from "@/api/auth/auth";
    import {parseTime, downloadFile} from "@/utils/index";
    import lightHeader from "@/components/lightHeader";

    import {MessageBox} from 'element-ui'
    import store from '@/store'

    export default {
        components: {
            lightHeader,
        },
        computed: {
            ...mapState(["companyList", "currentSpace", "userInfo"]),
            isUser() {
                return this.$route.query.isuse == 1 ? true : false;
            },
            uploadData() {
                if (this.currentSpace) {
                    return {companyId: this.currentSpace.companyId};
                } else {
                    return {companyId: ""};
                }
            },
            backUrl() {
                if (this.$route.query.from) {
                    return this.$route.query.from.replace(/\!\!/g, "?");
                } else {
                    return true;
                }
            },
        },
        data() {
            return {
                authorizationAddress:
                    ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL) ? GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL : process.env.VUE_APP_STATIC_RESOURCE_URL) + authorizationAddressPath,
                formLoading: false,
                type: "",
                addressOptions: [],
                addressProps: {
                    value: "code",
                    label: "name",
                },
                enterpriseTypeOptions: [],
                enterpriseScaleOptions: [],
                businessStatusOptions: [],
                signId: "",
                tenantId: this.$store.state.currentSpace.tenantId,
                spaceList: this.$store.state.spaceInfoList,
                filesForm: {
                    companyType: "company",
                    legalBackImgFileId: "",
                    legalBackImgBase64: "",
                    legalFrontImgFileId: "",
                    legalFrontImgBase64: "",
                    licenseImgFileId: "",
                    licenseImgBase64: "",
                    authFileImgFileId: "",
                    authFileImgBase64: "",
                    agentFrontImgFileId: "",
                    agentFrontImgBase64: "",
                    agentBackImgFileId: "",
                    agentBackImgBase64: "",
                },
                signFileInfoArray: [],

                // taskName: "",
                // signExpireTime: "",
                fileIdArray: [],

                clickSubmit: false,
                templateUploadUrl:
                    ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + "api/common/v1/tool/uploadSignFile",
                templateUrl:
                    ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + "contractTemplate/saveTemplate",
                myHeaders: {
                    Authorization: getToken(),
                },
                // uploadData: {
                //   companyId: this.currentSpace.companyId || ''
                // },
                dialogVisible: false,
                pngList: [],
                percentage: 0,

                filesRules: {},
                contractTypes: [],
                defaultPDF: require("../../../assets/images/sign/pdf.png"),

                isEdit: false,

                isReAuth: false,

                isProgess: false,

                uploadUrl:
                    ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + "api/common/v1/tool/uploadFile",
                upLoadData: {},
                agentAuthOpen: false,
                authCodeImg: null,
                qrcodeStatus: null,

                checkID: (rule, value, callback) => {
                    if (!this.IdentityCodeValid(value)) {
                        callback(new Error("身份证号输入有误！"));
                    } else {
                        callback();
                    }
                },


                checkChinese: (rule, value, callback) => {
                    var reg = /^[\u0391-\uFFE5]+$/;
                    if (!reg.test(value)) {
                        callback(new Error("只能输入中文！"));
                    } else {
                        callback();
                    }
                },

                checkCompanyID: (rule, value, callback) => {
                    var reg = /^[A-Z0-9]{18}$/;
                    if (!reg.test(value)) {
                        callback(
                            new Error("企业统一社会信用代码由18位数字或大写英文字母组成")
                        );
                    } else {
                        callback();
                    }
                },
            };
        },
        created() {
            this.isEdit = this.$route.query.edit == "yes";
            this.isReAuth = this.$route.query.re == "yes";
            this.type = this.$route.query.type;
            if (this.isEdit) {
                this.formLoading = true;
                getComapnayAuthInfo({userId: this.userInfo.userId}).then(res => {
                    this.filesForm = res.data;
                    this.formLoading = false;
                })
            }
            // getCityCode().then(({ data }) => {
            //   this.addressOptions = data.cityCode;
            // });
            // this.getDicts("cus_enterprise_type").then((response) => {
            //   this.enterpriseTypeOptions = response.data;
            // });
            // this.getDicts("cus_enterprise_scale").then((response) => {
            //   this.enterpriseScaleOptions = response.data;
            // });
            // this.getDicts("cus_business_status").then((response) => {
            //   this.businessStatusOptions = response.data;
            // });
        },
        mounted() {
            inspectTokenExpired();
        },
        methods: {
            closeAgentAuth(done){
                console.log("关闭经办人刷脸认证弹窗")
                if(this.timer){
                    clearInterval(this.timer);
                    this.timer = null;
                }
                if(this.outTimer){
                    clearTimeout(this.outTimer);
                    this.outTimer = null;
                }
                this.qrcodeStatus = null;
                done();
            },
            shuaxinQrcode() {
                this.qrcodeStatus = null;
                this.handleGetAgentAuthLink();
            },
            handleGetAgentAuthLink() {
                getAgentAuthLink({
                    idName: this.filesForm.agentName,
                    idNumber: this.filesForm.agentNo,
                    needQrcode: "yes",
                })
                    .then((res) => {
                        this.formLoading = false;
                        if (res.code != 200) {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "warning",
                            });
                        } else {
                            this.qrcodeStatus = null;
                            this.authCodeImg = res.data.authLinkQrcodeBase64;
                            this.authId = res.data.authId;
                            this.pollingResult();
                        }
                    })
                    .catch((err) => {
                        this.formLoading = false;
                        console.log(err);
                    });
            },
            handleRefreshAuthQrcode() {
                this.handleGetAgentAuthLink();
            },
            pollingResult() {
                if(this.timer){
                    clearInterval(this.timer);
                    this.timer = null;
                }
                if(this.outTimer){
                    clearTimeout(this.outTimer);
                    this.outTimer = null;
                }
                this.qrCodeOutDated = false;
                this.timer = setInterval(this.getAuthResultHandle, 3000);
                this.outTimer = setTimeout(() => {
                    clearInterval(this.timer);
                    this.timer = null;
                    this.qrCodeOutDated = true;
                    this.qrcodeStatus = "expired";
                }, 1000 * 60 * 5);
                // }, 1000);
            },
            getAuthResultHandle() {
                getAgentAuthResult({
                    authId: this.authId,
                })
                    .then((res) => {
                        if (res.code != 200) {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "warning",
                            });
                        } else {
                           if (res.data.status === "pass") {
                                this.qrcodeStatus = "pass";
                               if(this.timer){
                                   clearInterval(this.timer);
                                   this.timer = null;
                               }
                               if(this.outTimer){
                                   clearTimeout(this.outTimer);
                                   this.outTimer = null;
                               }
                               // 提交企业资料
                               this.handleSaveCompanyInfo();
                            } else if (res.data.status === "notPass") {
                               this.qrcodeStatus = "notPass";
                               if(this.timer){
                                   clearInterval(this.timer);
                                   this.timer = null;
                               }
                               if(this.outTimer){
                                   clearTimeout(this.outTimer);
                                   this.outTimer = null;
                               }
                            }

                           // else{
                           //
                           //     if(this.timer){
                           //         clearInterval(this.timer);
                           //         this.timer = null;
                           //     }
                           //     if(this.outTimer){
                           //         clearTimeout(this.outTimer);
                           //         this.outTimer = null;
                           //     }
                           //     this.qrcodeStatus = "pass";
                           //     this.$confirm("单位认证资料已提交到平台审核，工作日当天审核完成，节假日顺延至工作日审核完成，审核结果将以短信方式通知。", "成功提示", {
                           //         confirmButtonText: "返回首页",
                           //         showCancelButton:false,
                           //         type: "warning",
                           //         center: true,
                           //         showClose: false,
                           //         closeOnClickModal: false
                           //     }).then(() => {
                           //         this.$router.replace("/");
                           //     }).catch(() => { });
                           //
                           // }
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },

            closeTitleTop() {
                this.$confirm("直接退出编辑内容将会丢失，是否确认退出？", "提示", {
                    distinguishCancelAndClose: true,
                    confirmButtonText: "确认退出",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true,
                    showClose: true
                }).then(() => {
                    this.$router.replace("/");
                }).catch((action) => {
                });

            },

            IdentityCodeValid(code) {
                code = code.toUpperCase();
                var city = {
                    11: "北京",
                    12: "天津",
                    13: "河北",
                    14: "山西",
                    15: "内蒙古",
                    21: "辽宁",
                    22: "吉林",
                    23: "黑龙江 ",
                    31: "上海",
                    32: "江苏",
                    33: "浙江",
                    34: "安徽",
                    35: "福建",
                    36: "江西",
                    37: "山东",
                    41: "河南",
                    42: "湖北 ",
                    43: "湖南",
                    44: "广东",
                    45: "广西",
                    46: "海南",
                    50: "重庆",
                    51: "四川",
                    52: "贵州",
                    53: "云南",
                    54: "西藏 ",
                    61: "陕西",
                    62: "甘肃",
                    63: "青海",
                    64: "宁夏",
                    65: "新疆",
                    71: "台湾",
                    81: "香港",
                    82: "澳门",
                    91: "国外 "
                };
                var tip = "";
                var pass = true;

                if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X|x)$/i.test(code)) {
                    //if(!code || !/(^\d{17}(\d|X|x)$)/i.test(code)){
                    tip = "身份证号格式错误";
                    pass = false;
                } else if (!city[code.substr(0, 2)]) {
                    tip = "地址编码错误";
                    pass = false;
                } else {
                    //18位身份证需要验证最后一位校验位
                    if (code.length == 18) {
                        code = code.split('');
                        //∑(ai×Wi)(mod 11)
                        //加权因子
                        var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
                        //校验位
                        var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
                        var sum = 0;
                        var ai = 0;
                        var wi = 0;
                        for (var i = 0; i < 17; i++) {
                            ai = code[i];
                            wi = factor[i];
                            sum += ai * wi;
                        }
                        var last = parity[sum % 11];
                        if (parity[sum % 11] != code[17]) {
                            tip = "校验位错误";
                            pass = false;
                        }
                    }
                }
                //if(!pass) mui.toast(tip);
                return pass;
            },

            handleDispatchDateRangeChange(currentField) {
                if (
                    new Date(this.filesForm["dispatchstartdatetime"]) >
                    new Date(this.filesForm["dispatchenddatetime"])
                ) {
                    if (currentField == "1") {
                        this.filesForm["dispatchstartdatetime"] = "";
                    } else {
                        this.filesForm["dispatchenddatetime"] = "";
                    }
                    this.$message({
                        showClose: true,
                        message: "起始时间不得大于结束时间",
                        type: "warning",
                    });
                }
            },
            handleContractsDateRangeChange(currentField) {
                if (
                    new Date(this.filesForm["contractstartdatetime"]) >
                    new Date(this.filesForm["contractenddatetime"])
                ) {
                    if (currentField == "1") {
                        this.filesForm["contractstartdatetime"] = "";
                    } else {
                        this.filesForm["contractenddatetime"] = "";
                    }
                    this.$message({
                        showClose: true,
                        message: "起始时间不得大于结束时间",
                        type: "warning",
                    });
                }
            },
            handleProbationDateRangeChange(currentField) {
                if (
                    new Date(this.filesForm["probationstartdatetime"]) >
                    new Date(this.filesForm["probationenddatetime"])
                ) {
                    if (currentField == "1") {
                        this.filesForm["probationstartdatetime"] = "";
                    } else {
                        this.filesForm["probationenddatetime"] = "";
                    }
                    this.$message({
                        showClose: true,
                        message: "起始时间不得大于结束时间",
                        type: "warning",
                    });
                }
            },
            treeFind(tree, func) {
                for (const data of tree) {
                    if (func(data)) return data;
                    if (data.children) {
                        const res = this.treeFind(data.children, func);
                        if (res) return res;
                    }
                }
                return null;
            },
            handlerRegistrationAddressChange(data) {
                this.filesForm.registrationAddressProvince = data[0];
                this.filesForm.registrationAddressCity = data[1];
                this.filesForm.registrationAddressCounty = data[2];
                this.filesForm.registrationAddressProvincename = this.treeFind(
                    this.addressOptions,
                    (item) => {
                        return item.code == data[0];
                    }
                ).name;
                this.filesForm.registrationAddressCityname = this.treeFind(
                    this.addressOptions,
                    (item) => {
                        return item.code == data[1];
                    }
                ).name;
                this.filesForm.registrationAddressCountyname = this.treeFind(
                    this.addressOptions,
                    (item) => {
                        return item.code == data[2];
                    }
                ).name;
            },
            handleEnterprisedomicileaddressChange(data) {
                this.filesForm.enterprisedomicileaddressprovince = data[0];
                this.filesForm.enterprisedomicileaddresscity = data[1];
                this.filesForm.enterprisedomicileaddresscounty = data[2];
                this.filesForm.enterprisedomicileaddressprovincename = this.treeFind(
                    this.addressOptions,
                    (item) => {
                        return item.code == data[0];
                    }
                ).name;
                this.filesForm.enterprisedomicileaddresscityname = this.treeFind(
                    this.addressOptions,
                    (item) => {
                        return item.code == data[1];
                    }
                ).name;
                this.filesForm.enterprisedomicileaddresscountyname = this.treeFind(
                    this.addressOptions,
                    (item) => {
                        return item.code == data[2];
                    }
                ).name;
            },
            handlePersonaddressChange(data) {
                this.filesForm.personaddressprovince = data[0];
                this.filesForm.personaddresscity = data[1];
                this.filesForm.personaddresscounty = data[2];
                this.filesForm.personaddressprovincename = this.treeFind(
                    this.addressOptions,
                    (item) => {
                        return item.code == data[0];
                    }
                ).name;
                this.filesForm.personaddresscityname = this.treeFind(
                    this.addressOptions,
                    (item) => {
                        return item.code == data[1];
                    }
                ).name;
                this.filesForm.personaddresscountyname = this.treeFind(
                    this.addressOptions,
                    (item) => {
                        return item.code == data[2];
                    }
                ).name;
            },
            handleDomicileaddressChange(data) {
                this.filesForm.domicileAddressProvince = data[0];
                this.filesForm.domicileAddressCity = data[1];
                this.filesForm.domicileAddressCounty = data[2];
                this.filesForm.domicileAddressProvincename = this.treeFind(
                    this.addressOptions,
                    (item) => {
                        return item.code == data[0];
                    }
                ).name;
                this.filesForm.domicileAddressCityname = this.treeFind(
                    this.addressOptions,
                    (item) => {
                        return item.code == data[1];
                    }
                ).name;
                this.filesForm.domicileAddressCountyname = this.treeFind(
                    this.addressOptions,
                    (item) => {
                        return item.code == data[2];
                    }
                ).name;
            },

            returnIndex() {
                // this.$router.push('/')
                window.location.href = getConsoleUrl() + "/templateCenter/template";
            },
            handleFileSuccess(response, file, fileList) {
                if (response.code != 200) {
                    this.$message({
                        showClose: true,
                        message: response.message,
                        type: "warning",
                    });
                    // this.$refs.upload.clearFiles();
                    // this.isEdit = false
                    // this.fileId = "";
                    // this.fileIdArray = [];
                } else {
                    // this.defaultPDF =
                    this.fileIdArray.push(response.data.signFileId);
                    // this.filesForm.cname = file.name.substring(
                    // 	0,
                    // 	file.name.lastIndexOf(".")
                    // );
                    this.isUpload = true;

                    // var uploadTimer = null;
                    // var progressTimer = null;

                    // uploadTimer = setInterval(() => {
                    // 	this.percentage += 2;
                    // 	if (this.percentage >= 99) {
                    // 		this.percentage = 99;
                    // 		clearInterval(uploadTimer);

                    // 		progressTimer = setInterval(() => {
                    // 			contractTemplateImgApi(
                    // 				this.fileId || this.$route.query.templateId
                    // 			)
                    // 				.then(res => {
                    // 					if (res.code == "0") {
                    // 						this.percentage = 100;
                    // 						clearInterval(progressTimer);
                    // 					}
                    // 				})
                    // 				.catch(err => {
                    // 					console.log(err);
                    // 				});
                    // 		}, 1000);
                    // 	}
                    // }, 60);
                }
            },
            handleFileError(err, file, fileList) {
                console.log(err);
                this.$message({
                    showClose: true,
                    message: "文件上传失败！",
                    type: "warning",
                });
            },
            handleRemove(file) {
                // 缩略图模板里删除文件
                let fileList = this.$refs.upload.uploadFiles;
                let index = fileList.findIndex((fileItem) => {
                    return fileItem.uid === file.uid;
                });
                fileList.splice(index, 1);
                this.fileIdArray.splice(index, 1);
                // this.$refs.upload.clearFiles();
                // this.isEdit = false;
                // this.fileId = "";
                // this.percentage = 0;
            },
            checkContractName(rule, value, callback) {
                var reg = new RegExp(
                    '(?!((^(con)$)|^(con)/..*|(^(prn)$)|^(prn)/..*|(^(aux)$)|^(aux)/..*|(^(nul)$)|^(nul)/..*|(^(com)[1-9]$)|^(com)[1-9]/..*|(^(lpt)[1-9]$)|^(lpt)[1-9]/..*)|^/s+|.*/s$)(^[^/////:/*/?/"/</>/|]{1,50}$)'
                );
                if (!reg.test(value)) {
                    callback(new Error('合同名不能包含下列任何字符:/:*?"<>|'));
                } else {
                    callback();
                }
            },
            getContractImgsHandle() {
                return new Promise((resolve, reject) => {
                    contractTemplateImgApi(this.fileId || this.$route.query.templateId)
                        .then((res) => {
                            console.log(res);
                            if (res.code !== 200) {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: "warning",
                                });
                            } else {
                                resolve(res.data.pngList);
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                });
            },

            confirmSubmit(){
                this.$refs.filesForm.validate((valid) => {
                    console.log("表单提交，结果校验"+ valid)
                    if(valid){
                        this.agentAuthOpen = true;
                        this.handleGetAgentAuthLink();
                    }
                });
            },

            handleSaveCompanyInfo() {
                this.$refs.filesForm.validate((valid) => {
                    if (valid) {
                        this.formLoading = true;
                        let handlerName = (this.isEdit) ? updateCompanyAuthInfo : submitCompanyAuthInfo;
                        // 提交保存项
                        handlerName(this.filesForm)
                            .then((res) => {
                                this.formLoading = false;
                                this.agentAuthOpen = false;
                                if (res.code !== 200) {
                                    this.$message({
                                        showClose: true,
                                        message: res.message,
                                        type: "warning",
                                    });
                                } else {
                                    this.$confirm("单位认证资料已提交到平台审核，工作日当天审核完成，节假日顺延至工作日审核完成，审核结果将以短信方式通知。", "成功提示", {
                                        confirmButtonText: "返回首页",
                                        showCancelButton:false,
                                        type: "warning",
                                        center: true,
                                        showClose: false,
                                        closeOnClickModal: false
                                    }).then(() => {
                                        this.$router.replace("/");
                                    }).catch(() => { });
                                }
                                console.log(res);
                            })
                            .catch(() => {
                                this.formLoading = false;
                            });
                    }
                });
            },
            handleHandleAuthFileImgSuccessBeforeUpload(file) {
                if (
                    file.type == "image/png" ||
                    file.type == "image/jpeg" ||
                    file.type == "image/jpg"
                ) {
                } else {
                    this.$message.warning(`图片格式不正确，请重新上传图片！`);
                    return false;
                }
                if (file.size > 5 * 1024 * 1024) {
                    this.$message.warning(`图片大小超出5M限制，请重新上传图片！`);
                    return false;
                }
            },
            handleCompanyCardBeforeUpload(file) {
                if (
                    file.type == "image/png" ||
                    file.type == "image/jpeg" ||
                    file.type == "image/jpg"
                ) {
                } else {
                    this.$message.warning(`图片格式不正确，请重新上传图片！`);
                    return false;
                }
                if (file.size > 5 * 1024 * 1024) {
                    this.$message.warning(`图片大小超出5M限制，请重新上传图片！`);
                    return false;
                }
            },
            handleFrontCardBeforeUpload(file) {
                if (
                    file.type == "image/png" ||
                    file.type == "image/jpeg" ||
                    file.type == "image/jpg"
                ) {
                } else {
                    this.$message.warning(`图片格式不正确，请重新上传图片！`);
                    return false;
                }
                if (file.size > 5 * 1024 * 1024) {
                    this.$message.warning(`图片大小超出5M限制，请重新上传图片！`);
                    return false;
                }
            },
            handleBackCardBeforeUpload(file) {
                if (
                    file.type == "image/png" ||
                    file.type == "image/jpeg" ||
                    file.type == "image/jpg"
                ) {
                } else {
                    this.$message.warning(`图片格式不正确，请重新上传图片！`);
                    return false;
                }
                if (file.size > 5 * 1024 * 1024) {
                    this.$message.warning(`图片大小超出5M限制，请重新上传图片！`);
                    return false;
                }
            },
            handleResponseFail(response) {
                if (response.code == -10) {
                    MessageBox.confirm(
                        '登录状态已过期，请重新登录',
                        '系统提示',
                        {
                            showCancelButton: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                            showClose: false,
                            confirmButtonText: '重新登录',
                            type: 'warning',
                            center: false
                        }
                    ).then(() => {
                        store.dispatch('LogOut').then(() => {
                            location.reload() // 为了重新实例化vue-router对象 避免bug
                        })
                    })
                    return false;
                } else {
                    return true;
                }
            },
            handleAuthFileImgSuccess(response, file, fileList) {
                if (this.handleResponseFail(response)) {
                    this.filesForm.authFileImgBase64 = URL.createObjectURL(file.raw);
                    this.filesForm.authFileImgFileId = response.data.fileId;
                }

            },
            handleCompanyCardSuccess(response, file, fileList) {
                if (this.handleResponseFail(response)) {
                    this.filesForm.licenseImgBase64 = URL.createObjectURL(file.raw);
                    this.filesForm.licenseImgFileId = response.data.fileId;
                }
            },
            handleFrontCardSuccess(response, file, fileList) {
                if (this.handleResponseFail(response)) {
                    this.filesForm.legalFrontImgBase64 = URL.createObjectURL(file.raw);
                    this.filesForm.legalFrontImgFileId = response.data.fileId;
                }
            },
            handleFrontCardSuccessByAgent(response, file, fileList) {
                if (this.handleResponseFail(response)) {
                    this.filesForm.agentFrontImgBase64 = URL.createObjectURL(file.raw);
                    this.filesForm.agentFrontImgFileId = response.data.fileId;
                }
            },
            handleBackCardSuccess(response, file, fileList) {
                if (this.handleResponseFail(response)) {
                    this.filesForm.legalBackImgBase64 = URL.createObjectURL(file.raw);
                    this.filesForm.legalBackImgFileId = response.data.fileId;
                }
            },
            handleBackCardSuccessByAgent(response, file, fileList) {
                if (this.handleResponseFail(response)) {
                    this.filesForm.agentBackImgBase64 = URL.createObjectURL(file.raw);
                    this.filesForm.agentBackImgFileId = response.data.fileId;
                }
            },
        },
    };
</script>
<style>

    #tempcreate-layer{
        /*width: 1000px;*/
        /*margin-left: 300px;*/
    }

    #tempcreate-layer .el-table .cell {
        padding: 0 20px;
        font-size: 14px;
    }

    #tempcreate-layer .el-table tr {
        height: 72px;
    }

    #tempcreate-layer .el-table th > .cell {
        font-size: 14px;
    }

    .hide .el-upload--picture-card {
        display: none;
    }

    #tempcreate-layer .el-loading-spinner {
        height: 166px;
        margin-top: -43px;
    }

    .el-upload-list__item {
        transition: all 0.3s ease;
    }

    .desc-drawer .el-drawer__header {
        margin: 0;
        height: 67px;
        padding: 15px;
        border-bottom: 1px solid #eee;
    }
</style>
<style lang="scss" scoped>
    .tempcreate-content {
        /*width: 1200px;*/
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        margin-top: 54px;

        /deep/ .el-tabs--border-card {
            border: none;
            box-shadow: none;

            .el-tabs__header {
                background: #f0f0f5;
            }

            .el-tabs__item {
                margin-right: 12px;
                background: #e5e5e5;
                border: none;

                &.is-active {
                    background: #fff;
                }
            }

            .el-tabs__content {
                padding: 0;
            }
        }

        .tempcreate-files {
            background: #ffffff;
            overflow: hidden;
            padding: 27px 27px;

            .tempcreate-title {
                height: 23px;
                line-height: 23px;
                font-size: 18px;
                color: #333333;
                border-left: 3px solid #3296fa;
                text-indent: 10px;
                font-weight: 400;
                margin-bottom: 22px;
            }

            label {
                width: 98px;
                color: #666666;
                display: inline-block;
            }
        }
    }

    .tempcreate-users-box {
        padding: 15px 40px;
        background: #ffffff;
        margin-top: 18px;

        .add-btn {
            padding: 11px 14px;
            background: #3296fa;
            border-radius: 10px;
            font-size: 14px;
            text-align: center;
            font-weight: 400;
            color: #ffffff;
        }

        .sign-btns button.sign-button {
            padding: 12px 18px;
            background: #3296fa;
            border-radius: 10px;
            font-size: 14px;
            font-weight: 400;
            color: #ffffff;
        }
    }

    #tempcreate-layer {
        background: #f0f0f5;
        min-height: 100vh;
    }

    // .tempcreate-content {
    // 	width: 1200px;
    // 	margin: 30px auto;
    // }

    .upload-tip {
        position: relative;
        top: -120px;
        font-size: 14px;
        color: #999999;
    }

    .upload-tip2 {
        text-align: center;
        font-size: 14px;
        color: #d75c57;
        margin-top: 20px;
    }

    .upload-progress {
        width: 320px;
        margin: 10px auto 0;
    }

    .progress-title {
        font-size: 14px;
        color: #606266;
        float: left;
    }

    .progress-box {
        width: 320px;
        /* float: right; */
        margin-right: -30px;
        margin-top: 4px;
    }

    .files-form-box {
        width: 320px;
        margin: 26px auto 0;
    }

    .upload-template {
        height: 36px;
        /* background: #E85052; */
        color: #ffffff;
        margin-top: -5px;
        margin-left: 15px;
        width: 98px;
        float: left;
        overflow: hidden;
    }

    .sign-btns {
        width: 718px;
        margin: 20px auto 0;
        display: flex;
        justify-content: center;
        padding-bottom: 20px;
    }

    .sign-btns button {
        width: 140px;
        height: 45px;
        font-size: 14px;
    }

    #invoice-info-layer .el-form-item /deep/ .el-input__inner,
    #invoice-info-layer .el-form-item /deep/ .el-form-item__content,
    #invoice-info-layer .el-form-item /deep/ .el-date-editor,
    #company-info-layer .el-form-item /deep/ .el-input__inner,
    #company-info-layer .el-form-item /deep/ .el-form-item__content,
    #company-info-layer .el-form-item /deep/ .el-date-editor {
        width: 500px !important;
    }

    h4 {
        padding: 10px 0 30px;
        text-align: center;
    }

    .el-divider /deep/ .el-divider__text {
        color: #999;
    }

    .license-title {
        font-size: 18px;
        color: #333333;
        text-align: left;
    }

    .company-upload {
        position: relative;
        width: 148px;
        height: 158px;
        float: left;
        margin-left: 20px;
        margin-top: 20px;
    }

    .upload-text {
        position: absolute;
        left: 0;
        bottom: 10px;
        text-align: center;
        width: 100%;
        color: #999999;
        line-height: 20px;
        padding: 0 18px;
    }

    .upload-example {
        float: left;
        display: flex;
        width: 330px;
        justify-content: space-between;
        line-height: 148px;
        height: 144px;
        margin-left: 200px;
        margin-top: 20px;
        margin-right: 20px;
    }

    .example-box-wrap {
        line-height: 32px;
        text-align: center;
    }

    .example-box {
        width: 195px;
        height: 144px;
        border: 1px solid #dcdfe6;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .upload-example p {
        color: #333333;
    }

    .text-tip-item-wrap {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding: 0px 0px 15px;
        width: 90%;
        margin: 0 auto;
        line-height: 30px;

        p {
            margin-bottom: 0 !important;
        }
    }

    .text-tip-item p {
        font-size: 14px;
        color: #999;
        text-indent: 12px;
        margin-bottom: -10px;
    }

    #auth-info-company-layer .el-form-item__label {
        font-size: 18px;
        line-height: 48px;
    }

    #auth-info-company-layer .submit {
        width: 363px;
        height: 50px;
        margin: 60px auto 0;
        font-size: 18px;
        margin-bottom: 96px;
    }

    #auth-info-company-layer /deep/ .avatar-uploader .el-upload {
        border: 1px dashed #dcdfe6;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    #auth-info-company-layer /deep/ .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    #auth-info-company-layer /deep/ .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 148px;
        height: 148px;
        line-height: 148px;
        text-align: center;
    }

    #auth-info-company-layer /deep/ .avatar {
        width: 148px;
        height: 148px;
        display: block;
        position: relative;
        z-index: 3;
    }

    #auth-info-company-layer .el-form-item {
        /*width: 55%;*/
        /*margin: 0 auto 20px;*/
    }

    #auth-info-company-layer .el-form-item /deep/ .el-form-item__label {
        width: 100% !important;
        text-align: center;
    }

    .auth-img-tip-wrap {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        margin-left: 20px;
        line-height: 28px;
        text-align: left;
        width: 395px;
        color: #86909c;
        font-size: 11px;
        font-weight: 400;
        word-break: break-all;
    }

    .upload-example /deep/ .el-image__inner {
        vertical-align: middle;
    }


    .area-title {
        .title {
            font-size: 15px;
            font-weight: 500;
            color: #313843;
        }

        .sub {
            font-size: 11px;
            font-weight: 400;
            color: #86909C;

            & + .sub {
                margin-left: 8px;
            }
        }
    }

    .padding-20 {
        padding: 20px 20px 0;
    }

    .tempcreate-files {
        background: #fff;
        padding: 20px 30px 0;

        .tempcreate-title {
            padding: 1px 8px;
            font-size: 15px;
            font-weight: 400;
            color: #333333;
            border-left: 3px solid #3296fa;
        }
    }

    .title-top {
        height: 54px;
        font-size: 16px;
        font-weight: 500;
        color: #1D2129;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 20px;
        border-bottom: 1px solid #F2F3F5;
        background: #fff;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 9;

        .title {
            margin-left: 12px;
        }

        .el-button {
            height: 30px;
            line-height: 30px;
        }

        .el-button /deep/ span {
            display: flex;
            align-items: center;

            svg {
                margin-right: 8px;
            }
        }
    }

    .sys-tip-layer {
        /*width: calc(100% - 100px);*/
        /*width: 100%;*/
        width: 1200px;
        /*position: absolute;*/
        bottom: 40px;
        left: 50px;
        font-size: 13px;
        font-weight: 400;
        color: #86909C;
        background: #F7F8FA;
        border-radius: 10px;
        /*padding-left: 50px;*/
        padding: 30px;
        display: flex;
        align-items: center;


        .title {
            font-size: 13px;
            font-weight: 400;
            color: #3D3D3D;
        }

        .sub {
            color: #86909C;
            margin-left: 8px;
        }
    }

    .handle-sign {
        width: 760px;
        height: 350px;
        background: #F7F8FA;
        position: relative;

        .wexin {
            position: absolute;
            right: 0;
            top: 0;
        }
    }

</style>
